import { useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { ConversationView } from "@/components/admin/ConversationView";

const AdminBotConversationDetail = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();

  return (
    <Layout>
      <main className="flex-1 p-4 sm:p-6 lg:p-8 overflow-y-auto">
        <div className="max-w-5xl mx-auto space-y-6">
          <Link to="/admin/bot-conversations">
            <Button variant="ghost" size="sm">
              <ArrowLeft className="w-4 h-4 mr-1" />
              {t("admin.botConversations.backToList")}
            </Button>
          </Link>
          {id && <ConversationView conversationId={id} />}
        </div>
      </main>
    </Layout>
  );
};

export default AdminBotConversationDetail;
